module.exports = __webpack_public_path__ + "img/IC_EForm.5141c754.png";